import { useState, useEffect } from 'react'
import { Offcanvas } from 'react-bootstrap'

export default function StateOffcanvas({ handle, trigger, children, title, onHide }) {

	const [show, setShow] = useState(false)

	useEffect(() => {
		if (handle === trigger)
			setShow(true)
		else
			setShow(false)
	}, [handle, trigger])

	return (
		<Offcanvas show={show} onHide={onHide}>
			<Offcanvas.Header closeButton>
				<Offcanvas.Title>{title}</Offcanvas.Title>
			</Offcanvas.Header>
			<Offcanvas.Body>
				{children}
			</Offcanvas.Body>
		</Offcanvas>
	)
}
